import React from 'react';
import CreditCardPlusModuleView from './CreditCardPlusModuleView';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import { SESAME_PLUS_CARDS_OFFERS } from 'types/morph.pagePosition.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';

const CreditCardPlusModuleController = props => {
  const { offerInfo, offers, eventHandler, history } = props;

  const notQualify =
    offerInfo === 'NOT_QUALIFY_FOR_SESAME_PLUS_CARD' || offers?.length < 1;
  const isCreditBuilder = offerInfo === 'GOT_SESAME_CASH_CARD';

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: SESAME_PLUS_CARDS_OFFERS,
    modulePosition: props?.modulePosition,
    vertical: CREDIT_CARD_VERTICAL,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  const onClickLearnHowToImprove = () => {
    history.push('goals');
    eventHandler(CLICK, {
      'Click Type': 'Learn how to improve your grade',
      'Module name': SESAME_PLUS_CARDS_OFFERS,
    });
  };
  const onClickSeeMore = () => {
    history.push('offers');
    eventHandler(CLICK, {
      'Click Type': 'See all Cards',
      'Module name': SESAME_PLUS_CARDS_OFFERS,
    });
  };

  const onClickActionItems = () => {
    history.push('goals');
    eventHandler(CLICK, {
      'Click Type': 'Action items',
      'Module name': SESAME_PLUS_CARDS_OFFERS,
    });
  };

  return (
    <CreditCardPlusModuleView
      offers={offers}
      eventHandler={eventHandler}
      notQualify={notQualify}
      isCreditBuilder={isCreditBuilder}
      seenModule={seenModuleTracking}
      onClickLearnHowToImprove={onClickLearnHowToImprove}
      onClickSeeMore={onClickSeeMore}
      onClickActionItems={onClickActionItems}
    />
  );
};

export default CreditCardPlusModuleController;
